var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-data-table',{staticClass:"primary",attrs:{"color":"primary","dense":"","headers":_vm.headers,"items":_vm.tags,"items-per-page":30,"hide-default-header":"","hide-default-footer":"","disable-pagination":"","group-by":"point"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }